<template>
  <div class="dashboard__options--container">
    <v-menu
      v-model="menu"
      :nudge-bottom="10"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px">
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          :class="solid ? 'dashboard__options--input' : 'faccess_datepicker'"
        >
          <p >{{date_text_first}}</p>
          <img v-if="menu" src="@/assets/img/arrow-down.svg" style="transform: rotate(180deg); top: 40%; right: 10px;">
          <img v-else src="@/assets/img/arrow-down.svg" >
        </div>
      </template>
      <v-date-picker
        v-model="date"
        no-title
        scrollable>
      </v-date-picker>
    </v-menu>
    <v-menu
      v-model="menu2"
      :nudge-bottom="10"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px">
      <template v-slot:activator="{ on }">
        <div class="dashboard__options--input" v-on="on" >
          <p >{{date_text_last}}</p>
          <img v-if="menu2" src="@/assets/img/arrow-down.svg" style="transform: rotate(180deg); top: 40%; right: 10px;">
          <img v-else src="@/assets/img/arrow-down.svg" >
        </div>
      </template>
      <v-date-picker  v-model="date2" no-title scrollable>
      </v-date-picker>
    </v-menu>
    <button
      class="faccess_button"
      @click="filterQuery()">Consultar</button>
  </div>
</template>

<script>
  export default {
    props: {
      solid: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2:false,
      ate_text_first: new Date().toISOString().substr(0, 10),
      date_text_last: new Date().toISOString().substr(0, 10),
      datePickerFirstClick:false,
      hasAlreadyFilter:false,
      filterSearchedDate:new Date().toISOString().substr(0, 10),
      filterSearchedDate2:new Date().toISOString().substr(0, 10),
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      }
    },

    created() {
      this.date_text_first = this.formatDate(this.date)
      this.date_text_last = this.formatDate(this.date2)
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
        this.date_text_first = this.formatDate(this.date)
        this.dateFormatted = this.formatDate(this.date2)
        this.date_text_last = this.formatDate(this.date2)
      },
      date2 (val) {
        this.dateFormatted = this.formatDate(this.date2)
        this.date_text_last = this.formatDate(this.date2)
      }
    },

    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      filterQuery(){
        let vm = this
        vm.date_text_first = vm.date_text_first!="Desde" ? vm.date_text_first : ""
        vm.date_text_last = vm.date_text_last!="Hasta" ? vm.date_text_last : ""
        vm.$emit('filterQuery', { date_from: vm.date_text_first, date_to: vm.date_text_last })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/DatePicker.vue